import type { SelectOption } from "@repo/ui";

export type SchoolReportEntryType = "manual" | "file";

export type SchoolReportDetailsFormValues = {
  gradeId: string;
  boardId: string;
  examTypeId: string;
  examTypeLabel: string;
  schoolId: string;
  schoolLabel?: string;
};

export type SchoolReportDetailsField =
  | "grade"
  | "board"
  | "examType"
  | "school";

export type SchoolReportEntry = {
  id: string;
  title: string;
  type: SchoolReportEntryType;
  date: string;
  examTypeId?: number;
  examTypeCode?: string;
  boardId?: string;
  boardLabel?: string;
  schoolId?: string;
  schoolLabel?: string;
  fileKey?: string;
  subjects?: SchoolReportSubjectMark[];
};

export type SchoolReportGrade = {
  id: string;
  gradeLabel: string;
  boardId?: string;
  boardLabel?: string;
  reports: SchoolReportEntry[];
};

export type SchoolReportPendingDetails = SchoolReportDetailsFormValues & {
  gradeLabel: string;
  boardLabel: string;
  examTypeLabel: string;
  schoolLabel?: string;
  isAddExamFlow?: boolean;
};

export type SchoolReportSubjectMark = {
  subjectId: string;
  subjectLabel: string;
  obtained: string;
  max: string;
  minMarks?: number;
  maxMarks?: number;
};

export type SchoolReportMarksFormValues = {
  subjects: SchoolReportSubjectMark[];
  marksheetFile: File | null;
  marksheetFileKey?: string | null;
};

export type SchoolReportSavedMessage = {
  gradeLabel: string;
  examTitle: string;
};

export const SCHOOL_REPORT_MIN_MAX_MARKS = 20;
export const SCHOOL_REPORT_MAX_MARKS = 100;
export const SCHOOL_REPORT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const SCHOOL_REPORT_ALLOWED_FILE_TYPES = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  "image/png",
] as const;

export const SCHOOL_REPORT_FILE_ACCEPT =
  ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png";

export const MOCK_GRADE_OPTIONS: SelectOption[] = [
  { label: "Grade 9", value: "grade-9" },
  { label: "Grade 10", value: "grade-10" },
  { label: "Grade 11", value: "grade-11" },
  { label: "Grade 12", value: "grade-12" },
  { label: "Grade 5", value: "grade-5" },
  { label: "Grade 4", value: "grade-4" },
  { label: "Grade 3", value: "grade-3" },
  { label: "Grade 2", value: "grade-2" },
];

export function formatSchoolReportDate(date: Date): string {
  return date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
